import React from "react";

export default function QuickDateButtons({ setStart, setEnd }) {
  const today = new Date().toISOString().slice(0, 10);
  const yesterday = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
  const sevenDaysAgo = new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10);
  return (
    <div className="flex items-center gap-1.5" data-testid="quick-date-buttons">
      <button onClick={() => { setStart(today); setEnd(today); }} className="px-2 py-0.5 text-[9px] rounded bg-lime-500/10 text-lime-400 hover:bg-lime-500/20 border border-lime-500/20 font-medium">Hom nay</button>
      <button onClick={() => { setStart(yesterday); setEnd(yesterday); }} className="px-2 py-0.5 text-[9px] rounded bg-sky-500/10 text-sky-400 hover:bg-sky-500/20 border border-sky-500/20 font-medium">Hom qua</button>
      <button onClick={() => { setStart(sevenDaysAgo); setEnd(today); }} className="px-2 py-0.5 text-[9px] rounded bg-amber-500/10 text-amber-400 hover:bg-amber-500/20 border border-amber-500/20 font-medium">7 ngay</button>
    </div>
  );
}
